import { scrollToEl } from "../functions/window";

export const initAnchors = () => {
    document.querySelectorAll("[r-anchor]").forEach((anchor) => {
        if (anchor.classList.contains("r-anchor-initialized")) return;

        anchor.addEventListener("click", (event) => {
            event.preventDefault();
            scrollToEl(document.getElementById(event.currentTarget.getAttribute("r-anchor")), 40);
        });

        anchor.classList.add("r-anchor-initialized");
    });
};
